class DateHelper {
  static getHunDate(isoDate){
    var d = new Date(isoDate);
    var day = d.getDate();
    var m = DateHelper.MONTHS_HU[parseInt(d.getMonth() + 1)];
    var y = d.getFullYear();
    return y + '. ' + m + ' ' + day + '.';
  }

  static getHunTime(isoDate){
    var d = new Date(isoDate);
    var h = d.getHours();
    var m = d.getMinutes();
    //var s = d.getSeconds();
    return h + ':' + m;
  }
}

DateHelper.MONTHS_HU = ['', 'január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember', 'október', 'november', 'december'];

export default DateHelper